module.exports = __webpack_public_path__ + "static/img/21.a975ca5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/21.png
// module id = HNZP
// module chunks = 0